const es = {
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    create: "Crear",
    close: "Cerrar",
    back: "Atrás",
    next: "Siguiente",
    loading: "Cargando...",
    saving: "Guardando...",
    confirm: "Confirmar",
    yes: "Sí",
    no: "No",
    all: "Todos",
    none: "Ninguno",
    error: "Error",
    success: "Éxito",
    refresh: "Actualizar",
    logout: "Salir",
    dashboard: "Dashboard",
    settings: "Configuración",
    profile: "Perfil",
    today: "Hoy",
    noData: "Sin datos",
    copied: "Copiado",
    required: "Obligatorio",
    optional: "Opcional",
    minutes: "minutos",
    search: "Buscar",
  },
  auth: {
    welcome: "Bienvenido",
    loginSubtitle: "Inicia sesión en tu cuenta EVA AI",
    email: "Correo electrónico",
    password: "Contraseña",
    login: "Iniciar sesión",
    loggingIn: "Iniciando sesión...",
    forgotPassword: "¿Contraseña olvidada?",
    forgotPasswordTitle: "¿Contraseña olvidada?",
    forgotPasswordDesc: "Ingresa tu email para recibir un enlace de restablecimiento",
    enterEmail: "Por favor ingresa tu email",
    resetLinkSent: "Si el email existe, recibirás un enlace de restablecimiento",
    resetLinkSentLong: "Si el email existe en nuestro sistema, recibirás un enlace de restablecimiento en pocos minutos. Revisa también la carpeta de spam.",
    sendError: "Error al enviar",
    sending: "Enviando...",
    sendResetLink: "Enviar enlace de restablecimiento",
    backToLogin: "Volver al Login",
    setNewPassword: "Establecer nueva contraseña",
    setNewPasswordDesc: "Ingresa tu nueva contraseña",
    passwordResetSuccess: "¡Contraseña restablecida con éxito!",
    tokenInvalid: "Token inválido o expirado",
    invalidLink: "Enlace inválido. Solicita un nuevo enlace de restablecimiento.",
    requestNewLink: "Solicitar nuevo enlace",
    updating: "Actualizando...",
    noAccount: "¿No tienes cuenta?",
    signup: "Regístrate",
    emailRequired: "Correo y contraseña son obligatorios",
    loginSuccess: "¡Sesión iniciada correctamente!",
    invalidCredentials: "Credenciales no válidas",
    signupTitle: "Crear Cuenta",
    signupSubtitle: "Registra tu cuenta EVA AI",
    tenantName: "Nombre del Estudio/Negocio",
    confirmPassword: "Confirmar Contraseña",
    passwordMismatch: "Las contraseñas no coinciden",
    passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
    allFieldsRequired: "Todos los campos son obligatorios",
    signupSuccess: "¡Cuenta creada correctamente!",
    signingUp: "Registrando...",
    hasAccount: "¿Ya tienes cuenta?",
    currentPassword: "Contraseña Actual",
    newPassword: "Nueva Contraseña",
    confirmNewPassword: "Confirmar Nueva Contraseña",
    changePassword: "Actualizar Contraseña",
    changingPassword: "Actualizando...",
    passwordChanged: "Contraseña actualizada",
    minChars: "Mínimo 8 caracteres",
    wrongCurrentPassword: "Contraseña actual incorrecta",
    fillAllFields: "Completa todos los campos",
  },
  verifyEmail: {
    title: "Verifica tu correo",
    checking: "Verificando tu correo...",
    successTitle: "Correo verificado",
    successDesc: "Tu dirección de correo se ha verificado correctamente.",
    invalidTitle: "La verificación ha fallado",
    invalidDesc: "Este enlace de verificación no es válido o ha caducado. Puedes solicitar uno nuevo desde el panel.",
    missingToken: "Falta el token de verificación en este enlace.",
    goToDashboard: "Ir al panel",
    goToLogin: "Ir al inicio de sesión",
    bannerTitle: "Verifica tu correo",
    bannerDesc: "Verifica tu correo para recuperar tu cuenta y recibir avisos importantes del servicio.",
    resend: "Reenviar correo de verificación",
    sending: "Enviando...",
    sent: "Correo de verificación enviado. Revisa tu bandeja de entrada.",
    sendError: "No se pudo enviar el correo de verificación. Inténtalo más tarde.",
  },

  dashboard: {
    completeSetup: "Completar Configuración",
    activateSubscription: "Activa tu suscripción para usar EVA AI.",
    configureWhatsApp: "Configura WhatsApp para empezar a recibir mensajes.",
    startSetup: "Iniciar Setup",
    subscription: "Suscripción",
    founderPlan: "Plan founder con acceso completo",
    monthlyActive: "99 CHF/mes - Activo",
    setupRequired: "Configuración necesaria",
    activateBtn: "Activar Suscripción",
    whatsapp: "WhatsApp",
    phoneNumber: "Número",
    notSpecified: "No especificado",
    notConfigured: "Sin configuración",
    configure: "Configurar",
    messages: "Mensajes",
    lastMessages: "Últimos mensajes recibidos",
    evaStatus: "Estado EVA",
    evaActive: "Eva Activa",
    evaPaused: "Eva en Pausa",
    autoResponses: "Respuestas automáticas",
    quickPause: "Pausa rápida",
    pausedFor: "Eva en pausa por {minutes} minutos",
    evaReactivated: "Eva reactivada",
    languageControl: "Control de Idioma",
    languageControlDesc: "Establece el idioma predeterminado y fuerza para todos los contactos",
    defaultLanguage: "Idioma Predeterminado",
    forceLanguage: "Forzar Idioma Global",
    forceLanguageOn: "Todos los contactos recibirán respuestas en este idioma",
    forceLanguageOff: "Eva detecta el idioma automáticamente",
    saveLanguage: "Guardar Control de Idioma",
    languageSaved: "Control de idioma guardado",
    quickActions: "Acciones Rápidas",
    openInbox: "Abrir Inbox",
    calendar: "Calendario",
    setupWizard: "Asistente de Setup",
    refreshData: "Actualizar Datos",
    recentMessages: "Mensajes Recientes",
    recentMessagesDesc: "Últimos 10 mensajes recibidos",
    noMessages: "Sin mensajes aún",
    noMessagesHint: "Los mensajes aparecerán aquí cuando empieces a recibir solicitudes",
    contact: "Contacto",
    direction: "Dirección",
    message: "Mensaje",
    language: "Idioma",
    date: "Fecha",
    received: "Recibido",
    sent: "Enviado",
    subscriptionActivated: "Suscripción activada",
    checkoutReceived: "Checkout recibido, verificando...",
    dataLoadError: "Error al cargar los datos",
    statusUpdateError: "Error al actualizar el estado",
    pauseError: "Error en la pausa",
    languageSaveError: "Error al guardar",
    contactLanguageUpdated: "Idioma del contacto actualizado",
    contactLanguageError: "Error al actualizar",
    active: "Activo",
    pastDue: "Pago Pendiente",
    canceled: "Cancelado",
    incomplete: "Incompleto",
    connected: "Conectado",
  },
  calendar: {
    title: "Calendario de Citas",
    confirmed: "confirmadas",
    pending: "pendientes",
    blocked: "bloqueadas",
    arriving: "llegando",
    noAppointments: "Sin citas",
    noAppointmentsDay: "Sin citas para este día",
    newAppointment: "Nueva",
    blockSlot: "Bloquear",
    girlFilter: "Chica",
    statusFilter: "Estado",
    allGirls: "Todas",
    activeFilter: "Activas",
    confirmedFilter: "Confirmadas",
    pendingFilter: "Pendientes",
    blockedFilter: "Bloqueadas",
    completedFilter: "Completadas",
    appointmentDetail: "Detalle de Cita",
    blockedSlot: "Slot Bloqueado",
    girl: "Chica",
    dateLabel: "Fecha",
    time: "Hora",
    duration: "Duración",
    whatsappLabel: "WhatsApp",
    buzzer: "Timbre",
    notes: "Notas",
    dateTime: "Fecha/Hora",
    status: "Estado",
    arrivalStatus: "Estado de Llegada",
    noChanges: "Sin cambios",
    appointmentUpdated: "Cita actualizada",
    deleted: "Eliminado",
    newAppointmentTitle: "Nueva Cita",
    girlRequired: "Chica y fecha/hora son obligatorios",
    appointmentCreated: "Cita creada",
    clientPhone: "WhatsApp cliente",
    languageOptional: "Idioma",
    buzzerOptional: "Timbre",
    createAppointment: "Crear Cita",
    creating: "Creando...",
    blockSlotTitle: "Bloquear Slot",
    blockDuration: "Duración",
    blockReason: "Motivo / Notas",
    blockReasonPlaceholder: "Ej.: Pausa, no disponible, etc.",
    blockSubmit: "Bloquear Slot",
    blocking: "Bloqueando...",
    slotBlocked: "Slot bloqueado",
    loadError: "Error al cargar las citas",
    blocked_label: "BLOQUEADO",
  },
  settings: {
    title: "EVA AI - Configuración",
    whatsappConfig: "Configuración WhatsApp",
    whatsappConfigDesc: "Gestiona las credenciales de WhatsApp Business API",
    webhookUrl: "URL Webhook",
    phoneNumberId: "Phone Number ID",
    accessToken: "Access Token",
    accessTokenStored: "Token guardado",
    accessTokenStoredHint: "El token está guardado de forma segura. No tienes que volver a introducirlo.",
    replaceAccessToken: "Sustituir token",
    replaceAccessTokenHint: "Introduce un token nuevo solo si quieres sustituir el que está guardado.",
    accessTokenRequiredHint: "Introduce el token de Meta. Después de guardarlo, permanecerá almacenado de forma segura.",
    verifyToken: "Verify Token",
    phoneNumber: "Número de Teléfono",
    saveWhatsApp: "Guardar Configuración WhatsApp",
    whatsappSaved: "Configuración WhatsApp guardada",
    generalSettings: "Configuración General",
    generalSettingsDesc: "Personaliza el comportamiento de EVA AI",
    defaultLanguage: "Idioma Predeterminado",
    forceLanguage: "Forzar Idioma Global",
    forceLanguageDesc: "Ignora la detección automática y usa siempre este idioma",
    forcedLanguage: "Idioma Forzado",
    durations: "Duraciones (minutos, separadas por coma)",
    externalDetailsLink: "Link de Detalles Externos (compliance)",
    pricingText: "Texto de Precios",
    rules: "Reglas",
    locationInfo: "Información de Ubicación",
    welcomeMessage: "Mensaje de Bienvenida",
    saveSettings: "Guardar Configuración",
    settingsSaved: "Configuración guardada",
    studioConfig: "Configuración del Estudio",
    studioConfigDesc: "Configuración pública para info y reservas",
    studioName: "Nombre del Estudio",
    publicInfoUrl: "Link Oficial (Servicios/Precios/Chicas)",
    publicInfoUrlWarning: "Sin un link válido (http:// o https://) EVA no puede enviar el link para servicios/precios/chicas. Responderá con tono amable y guiará hacia la reserva, pero sin compartir el link.",
    publicInfoUrlHint: "Este link se usará para responder consultas sobre servicios, precios y chicas",
    girlsList: "Chicas (una por línea)",
    girlsListHint: "Si hay más de una chica, EVA preguntará. Si solo hay una, selección automática.",
    saveStudio: "Guardar Configuración del Estudio",
    saveError: "Error al guardar",
    loadError: "Error al cargar los datos",
    urlCopied: "URL copiado",
  },
  wizard: {
    title: "Configuración EVA AI",
    stepOf: "Paso {step} de {total}",
    billingTitle: "Suscripción",
    billingDesc: "Activa tu suscripción mensual para usar EVA AI",
    founderTitle: "Plan Internal (Founder)",
    founderDesc: "Tienes acceso completo a todas las funcionalidades sin suscripción.",
    founderHint: "Puedes proceder directamente a la configuración de WhatsApp.",
    subscriptionActive: "¡Suscripción activa! Puedes continuar con la configuración.",
    standardPlan: "Plan Estándar",
    standardPlanDesc: "Todo incluido, sin compromiso",
    perMonth: "al mes",
    featureWhatsApp: "Integración WhatsApp Cloud API",
    featureMultilang: "Soporte multilingüe (IT/DE/EN/ES)",
    featureBooking: "Motor de reservas FSM",
    featureDashboard: "Dashboard y analíticas",
    activateSubscription: "Activar Suscripción",
    activating: "Abriendo Checkout...",
    stripeRedirect: "Serás redirigido a Stripe para completar el pago de forma segura.",
    privatePilotBilling: "EVA está en un piloto privado: las suscripciones y los cargos están desactivados hasta que el servicio se abra a la venta.",
    privatePilotClosed: "Pagos cerrados durante el piloto",
    whatsappTitle: "Configuración WhatsApp",
    whatsappDesc: "Conecta tu cuenta de WhatsApp Business",
    webhookUrl: "URL Webhook",
    phoneNumberId: "Phone Number ID",
    phoneNumberIdHint: "Encuéntralo en Meta Business Manager → WhatsApp → API Setup",
    accessToken: "Access Token",
    verifyToken: "Verify Token",
    verifyTokenHint: "Usa este valor proporcionado por EVA cuando Meta solicite el Verify Token del webhook. EVA lo gestiona.",
    phoneNumber: "Número de Teléfono",
    fillRequired: "Completa todos los campos obligatorios",
    whatsappSaved: "Configuración WhatsApp guardada",
    settingsTitle: "Configuración",
    settingsDesc: "Personaliza el comportamiento de EVA AI",
    defaultLanguage: "Idioma Predeterminado",
    durations: "Duraciones Disponibles (minutos, separadas por coma)",
    externalDetailsLink: "Link de Detalles Externos (IMPORTANTE para compliance)",
    externalDetailsHint: "EVA redirigirá a este link cuando reciba media o solicitudes explícitas",
    pricingText: "Texto de Precios",
    rules: "Reglas",
    locationInfo: "Información de Ubicación",
    welcomeMessage: "Mensaje de Bienvenida",
    settingsSaved: "Configuración guardada",
    testTitle: "Mensaje de Prueba",
    testDesc: "Envía un mensaje de prueba para verificar la configuración",
    testAlmostDone: "¡Setup casi listo! Envía un mensaje de prueba para confirmar que todo funciona.",
    recipient: "Número del Destinatario (formato internacional, sin +)",
    recipientHint: "Ej.: 41791234567 para un número suizo",
    messageLabel: "Mensaje",
    sendTest: "Enviar Mensaje de Prueba",
    sending: "Enviando...",
    testSent: "¡Mensaje de prueba enviado correctamente!",
    testCheckPhone: "Revisa tu teléfono para verificar la recepción del mensaje",
    fillRecipient: "Ingresa número y mensaje",
    completeSetup: "Completar Setup",
    setupComplete: "¡Setup completado!",
    checkoutError: "Error al abrir el checkout",
  },
  account: {
    title: "EVA AI - Perfil",
    subscription: "Suscripción",
    subscriptionDesc: "Gestiona tu plan y suscripción",
    plan: "Plan",
    status: "Estado",
    nextRenewal: "Próxima renovación",
    scheduledCancel: "Cancelación programada",
    cancelWarning: "La suscripción permanecerá activa hasta el final del período ya pagado ({date}).",
    founderAlert: "Plan Founder: acceso ilimitado sin costos.",
    price: "Precio",
    validUntil: "Válido hasta",
    scheduledCancelAlert: "Cancelación programada: La suscripción terminará al final del período en curso.",
    cancelSubscription: "Cancelar Suscripción (Fin del Período)",
    cancelConfirmTitle: "¿Confirmar cancelación?",
    cancelConfirmDesc: "La cancelación tendrá efecto al final del período ya pagado. El mes en curso no es reembolsable.",
    confirmCancel: "Confirmar Cancelación",
    canceling: "Cancelando...",
    cancelSuccess: "Cancelación programada",
    cancelError: "Error en la cancelación",
    security: "Seguridad",
    securityDesc: "Cambia la contraseña de tu cuenta",
    active: "Activo",
    pastDue: "Pago Pendiente",
    canceledStatus: "Cancelado",
    incompleteStatus: "Incompleto",
    founderInternal: "Founder / Internal",
    standard: "Estándar",
    yourData: "Tus datos",
    yourDataDesc: "Exporta los datos de tu cuenta o solicita la eliminación asistida",
    dataLifecycleNotice: "La exportación excluye contraseñas, credenciales de proveedores y datos de tarjetas. Las solicitudes se verifican sin prometer plazos no demostrados.",
    downloadData: "Descargar mis datos",
    dataExportSuccess: "La exportación está lista",
    dataExportError: "No se pudieron exportar los datos",
    requestDeletion: "Solicitar eliminación de cuenta",
    deletionConfirmTitle: "¿Solicitar eliminación?",
    deletionConfirmDesc: "La solicitud se registrará para verificación operativa. Suscripción, obligaciones legales, terceros y copias de seguridad deben gestionarse antes del cierre.",
    deletionConfirmationLabel: "Escribe DELETE MY EVA ACCOUNT",
    submitDeletionRequest: "Enviar solicitud",
    deletionRequestSuccess: "Solicitud de eliminación registrada",
    deletionRequestError: "No se pudo registrar la solicitud",
  },
  inbox: {
    title: "EVA AI - Inbox",
    conversations: "Conversaciones",
    noConversations: "Sin conversaciones",
    noConversationsHint: "Las conversaciones aparecerán aquí cuando recibas mensajes",
    messagesLabel: "mensajes",
    lastActivity: "última actividad",
    typeMessage: "Escribe un mensaje...",
    send: "Enviar",
    selectConversation: "Selecciona una conversación",
    selectConversationHint: "Elige una conversación de la lista para ver los mensajes",
    messageSent: "Mensaje enviado",
    messageSendError: "Error al enviar el mensaje",
    loadError: "Error al cargar las conversaciones",
    messagesLoadError: "Error al cargar los mensajes",
    eva: "EVA",
    client: "Cliente",
    manualMode: "Manual",
    manualModeActive: "Modo manual activo. Eva no responderá automáticamente.",
    manualModeActivated: "Modo manual activado",
    evaReactivated: "Eva reactivada",
    modeChangeError: "Error al cambiar modo",
    noMessages: "Sin mensajes",
    active: "Activo",
    optedOut: "Desactivado",
    now: "Ahora",
    minutesAgo: "hace {n}m",
    hoursAgo: "hace {n}h",
    unreadNew: "nuevo",
    unreadNewPlural: "nuevos",
    contacts: "contactos",
    contact: "contacto",
  },
  languages: {
    it: "Italiano",
    de: "Alemán",
    en: "Inglés",
    es: "Español",
    auto: "Auto",
  },
  signup: {
    title: "Crea Tu Cuenta",
    subtitle: "Empieza a usar EVA AI en pocos minutos",
    button: "Crear Cuenta",
    creating: "Creando...",
    termsAccept: "Al crear una cuenta aceptas nuestros",
    termsOfService: "Términos de Servicio",
    and: "y la",
    privacyPolicy: "Política de Privacidad",
    legalConsentPrefix: 'Acepto los',
    legalConsentAndPrivacy: 'y confirmo que he leído la',
    legalRequired: 'Para crear la cuenta debes aceptar los Términos y el DPA y confirmar que has leído la Política de Privacidad.',
    legalUnavailable: 'La información legal no está disponible temporalmente. Recarga la página antes de registrarte.',
    nonCommercialLegal: 'Este entorno aún no está configurado para uso comercial; faltan datos legales.',
    privatePilotTitle: "Piloto privado solo por invitación",
    privatePilotDesc: "Los nuevos registros y pagos están temporalmente cerrados. Los usuarios ya invitados pueden seguir iniciando sesión y probando EVA.",
    privatePilotLogin: "Acceder al piloto",
  },
  uiLanguage: {
    label: "Idioma de interfaz",
    selectorTitle: "Idioma",
  },
  landing: {
    login: "Iniciar sesión",
    startNow: "Empezar ahora",
    heroTitle1: "El asistente WhatsApp",
    heroTitle2: "para las reservas de tu estudio",
    heroSubtitle: "Automatiza reservas, solicitudes de clientes y gestión de citas por WhatsApp con EVA AI. Multilingüe, conforme y listo en pocos minutos.",
    heroCta: "Empezar ahora",
    learnMore: "Saber más",
    featuresTitle: "Funcionalidades principales",
    featuresSubtitle: "Todo lo que necesitas para gestionar reservas y solicitudes de clientes por WhatsApp",
    feature1Title: "Automatización WhatsApp",
    feature1Desc: "Asistente automático para reservas y solicitudes de clientes por WhatsApp.",
    feature2Title: "Soporte multilingüe",
    feature2Desc: "Italiano, alemán, inglés y español con gestión coherente del idioma.",
    feature3Title: "Motor de reservas inteligente",
    feature3Desc: "Comprende solicitudes naturales y gestiona reservas con fecha, hora y duración de forma fiable.",
    feature4Title: "Compliance integrado",
    feature4Desc: "Gestión STOP/START, redirección de media y control de contenidos sensibles.",
    pricingTitle: "Precio simple y claro",
    pricingSubtitle: "Un solo plan, todo incluido",
    planName: "Plan Estándar",
    planPeriod: "al mes, sin compromiso",
    bullet1: "Integración WhatsApp Cloud API",
    bullet2: "Soporte multilingüe (IT/DE/EN/ES)",
    bullet3: "Motor de reservas inteligente",
    bullet4: "Dashboard y estadísticas",
    bullet5: "Conformidad GDPR/FADP",
    privacy: "Privacidad",
    terms: "Términos",
    dpa: "DPA",
  },
  alerts: {
    bookingCreated: "Nueva Reserva",
    bookingUpdated: "Reserva Modificada",
    bookingCancelled: "Reserva Cancelada",
    customerArrival: "Cliente Llegando",
    manualModeMessage: "Mensaje (EVA apagada)",
    girl: "Chica",
    time: "Hora",
    duration: "Duración",
    client: "Cliente",
    source: "Fuente",
    whatsapp: "WhatsApp",
    manual: "Manual",
    changed: "Cambiado",
    unknown: "Desconocido",
    phone: "Teléfono",
    arrivalHelp: "Ayuda llegada",
    soundOn: "Sonido alert ON",
    soundOff: "Sonido alert OFF",
    noAlerts: "Sin alertas recientes",
    recentAlerts: "Alertas Recientes",
    clearAll: "Borrar todo",
    dismiss: "Eliminar",
    viewCalendar: "Calendario",
    viewInbox: "Bandeja",
    min: "min",
    arrivalIncoming: "en camino",
    arrivalOutside: "en el sitio",
    arrivalAtDoor: "en la puerta",
    arrivalArrived: "llegó",
  },
};

export default es;
